module.exports = __webpack_public_path__ + "static/media/SwiftShop_wk6_err1.e2a11462.png";